<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
    @if (message) {
    {{message}}
    }
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
    <button mat-button class="delete" (click)="onCancel()">{{confirmText}}</button>
</mat-dialog-actions>